<template>
  <div style="text-align: justify;" class="center testonormale">
    <span class="testoblu">{{S0001}}</span>
    <p>{{ S0002 }}</p>
    <p>{{ S0003 }}</p>
    <ul>
      <li><strong>
          <router-link :to="{ name: 'PageFoodByName', params: { lang: lang } }">{{PageFoodByName}}</router-link>
        </strong> {{PageFoodByNameDesc}} 
        <br>
      </li>
      <li><strong>
          <router-link :to="{ name: 'PageFoodByCode', params: { lang: lang } }">{{PageFoodByCode}}</router-link>
        </strong> {{ PageFoodByCodeDesc }} <br>
      </li>
      <li><strong>
          <router-link :to="{ name: 'PageFoodByCategory', params: { lang: lang } }">{{PageFoodByCategory}}</router-link>
        </strong> {{PageFoodByCategoryDesc }} <br>
      </li>
      <li><strong>
          <router-link :to="{ name: 'PageFoodByComponent', params: { lang: lang } }">{{ PageFoodByComponent }}</router-link>
        </strong> {{ PageFoodByComponentDesc }} <br>
      </li>
      <li><strong>
          <router-link :to="{ name: 'PageFoodList', params: { lang: lang } }">{{PageFoodList}}</router-link>
        </strong> {{ PageFoodListDesc }} 
      </li>
    </ul>
  </div>
</template>

<script>
import { getSTRING } from '@/js/utils';
export default {
  name: "PageMain",
  data() {
    return {
      lang: this.$route.params.lang,
      S0001: "",
      S0002: "",
      S0003: "",
      PageFoodByName : "",
      PageFoodByCode: "",
      PageFoodByCategory: "",
      PageFoodByComponent: "",
      PageFoodList: "" ,
      PageFoodByNameDesc : "",
      PageFoodByCodeDesc: "",
      PageFoodByCategoryDesc: "",
      PageFoodByComponentDesc: "",
      PageFoodListDesc: "" 
    }
  },
  mounted() {
     this.S0001 = getSTRING(this.lang, "S0001" , "RICERCA DATI:")
     this.S0002 = getSTRING(this.lang, "S0002" , "La Banca Dati di composizione degli alimenti per studi Epidemiologici in Italia contiene informazioni relative al contenuto di nutrienti e componenti degli alimenti più comunemente consumati dalla popolazione italiana.")
     this.S0003 = getSTRING(this.lang, "S0003" , "E' possibile cercare nel database in modi differenti:")
     
     this.PageFoodByName = getSTRING(this.lang, "PageFoodByName" , "Per nome alimento:")
     this.PageFoodByCode = getSTRING(this.lang, "PageFoodByCode" , "Per codice alimento:")
     this.PageFoodByCategory = getSTRING(this.lang, "PageFoodByCategory" , "Per categoria merceologica:")
     this.PageFoodByComponent = getSTRING(this.lang, "PageFoodByComponent" , "Per componente o nutriente:")
     this.PageFoodList = getSTRING(this.lang, "PageFoodList" , "Visualizzazione lista alimenti:")

     this.PageFoodByNameDesc = getSTRING(this.lang, "PageFoodByNameDesc" , "E' possibile effettuare una ricerca digitando il nome dell'alimento, il nome scientifico o parti di essi.")
     this.PageFoodByCodeDesc = getSTRING(this.lang, "PageFoodByCodeDesc" , "E' possibile effettuare una ricerca digitando il codice identificativo.")
     this.PageFoodByCategoryDesc = getSTRING(this.lang, "PageFoodByCategoryDesc" , "E' possibile effettuare una ricerca all'interno delle categorie merceologiche, cliccando sulla categoria corrispondente. Gli alimenti sono raggruppati in 28 categorie merceologiche, cioè gruppi di alimenti con caratteristiche simili.")
     this.PageFoodByComponentDesc = getSTRING(this.lang, "PageFoodByComponentDesc" , "E' possibile effettuare una ricerca mirata su uno o piu componenti (al massimo tre), e definendo la quantità (fissa, range,ecc).")
     this.PageFoodListDesc = getSTRING(this.lang, "PageFoodListDesc" , "E' possibile visualizzare tutti gli alimenti inclusi nel database in ordine alfabetico.")
    } 
};
</script>

<style></style>